import React from 'react';

import style from './PlaylistGesturalNavigation.module.scss';

const PlaylistGesturalNavigation = ({
  isPlaylistOpen,
  activeVideo,
  navigateVideos,
}) => {
  return (
    <div
      className={style.navigationWrapper}
      style={{ pointerEvents: isPlaylistOpen ? 'auto' : 'none' }}
    >
      <div
        className={style.navigationLeft}
        onClick={() => navigateVideos('prev')}
      />
      <div
        className={style.navigationRight}
        onClick={() => navigateVideos('next')}
      />
    </div>
  );
};

export default PlaylistGesturalNavigation;



// WEBPACK FOOTER //
// ./src/components/global/playlist/PlaylistGesturalNavigation.js